<div class="container">


    <div class="pt-3 pb-2">
      <div class="row g-0 align-items-center">


        <div class="col-12">

            <div class="draft-banner mt-3">
                <div class="draft-banner__heading">
                    <span>Buat RFQ dengan mudah, penawaran datang otomatis.</span>
                </div>
                <div class="draft-banner__features">
                    <div class="draft-banner__feature-item">
                        <i class="bi bi-check-circle-fill"></i> Single RFQ Posting
                    </div>
                    <div class="draft-banner__feature-item">
                        <i class="bi bi-check-circle-fill"></i> AI Vendor Matching
                    </div>
                    <div class="draft-banner__feature-item">
                        <i class="bi bi-check-circle-fill"></i> Quotation Comparison
                    </div>
                </div>
            </div>


        </div>

        <div class="col-sm-12">
            <app-breadcrumb 
                returnAction="/" 
                [breadcrumbs]="[
                    { label: '/ &nbsp;&nbsp; Buat RFQ' } 
                ]"
            >
            </app-breadcrumb>
        </div>
      </div>
    </div>


<!-- 
    <app-assistance assistanceTitle="User Hint" assistanceText="{{'rfq.new' | translate}}" assistanceType="procurement" assistanceStepper='[{"text":"RFQ Published","status":false},{"text":"Vendor Create Quotation","status":false },{"text":"Order Products","status":false},{"text":"Proforma PO <b>(Done!)</b>","status":false}]'></app-assistance>
 -->


          <!-- Quotation -->
          <form [formGroup]="rfqForm" (ngSubmit)="onSubmit()">
            <div>
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="cd-title">
                    
                    <div class="row">
                      <div class="col-12">
                        {{ EditRfqId!==null ? 'Ubah RFQ':'Buat RFQ' }}
                      </div>
                      <!-- <div class="col-4 text-end">
                        <font></font>
                      </div> -->
                    </div>



                  </div>
                </div>


                        <div class="col-sm-12 mt-0 pt-0" *ngIf="successdraft">

                            <div class="alert alert-success alert-dismissible fade show rounded-1 successNotif" role="alert">
                                <strong>{{'success.text' | translate}}</strong> : {{'success.message' | translate}}
                                <p class="btn-close successNotif" (click)="closesuccessdraft()"></p>
                            </div>
                            

                        </div>

                        <div class="col-sm-12 mt-0 pt-0" *ngIf="rfqFormInvalid">

                            <div class="alert alert-danger alert-dismissible fade show rounded-1 errorNotif" role="alert">
                                <strong>{{'warning' | translate}}</strong> : {{'rfq.invalid_input' | translate}}
                                <p class="btn-close errorNotif" (click)="closerfqFormInvalid()"></p>
                            </div>
                            

                        </div>

                        <div class="col-sm-12 p-3 p-sm-5 pt-0 pt-sm-3 pb-0 pb-sm-0 isHide">
                            <div class="form-group mb-0 mb-sm-3 row">
                                <label for="sku" class="col-sm-2 col-form-label">Vendor Category <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.vendor_category' | translate}}"  container="body"></i></sup></label>
                                <div class="col-sm-10 ps-sm-0">
                                    <textarea [(ngModel)]="ValrfqVendorCategory" formControlName="rfqVendorCategory" class="form-control placeholderRfq d-none" [ngClass]="{ 'is-invalid': submitted && f?.rfqVendorCategory?.errors }"></textarea>

                                    <div class="divcategories placeholderRfq" [ngClass]="{ 'invalidcategories': submitted && f?.rfqVendorCategory?.errors }">
                                  

                                        <div class="row g-0">
                                            <div class="col-11  cursor-text" *ngIf="selectedCat?.length > 0"  (click)="modalCategory()">
                                                    <span class="badge rounded-pill bg1 ps-3 me-2 catpillshown" *ngFor="let category of selectedCat; let i = index" (click)="$event.stopPropagation()">{{getCategoryName(category)}} <i class="bi bi-x pointer" (click)="removeCat(category);$event.stopPropagation()"></i></span>
                                            </div>

                                            <div class="col-11 cursor-text" *ngIf="selectedCat?.length == 0" (click)="modalCategory()">
                                                <font class="placeholderRfq">Select Categories</font>
                                            </div>




                                            <div class="col-1 text-end pointer"  (click)="modalCategory()"><img src="/assets/images/icons/ic_SearchBlack.png" class=""></div>
                                        </div>
                                    </div>
                          
                                    <div class="form-check form-check-inline d-none" *ngFor="let tag of tags; let i = index">
                                        <input (change)="onChangeTag(tag.id,$event)" class="form-check-input" type="checkbox" id="inlineCheckbox{{tag.id}}" value="{{tag.id}}" [checked]="(SelectedTags.indexOf(tag.id)>-1)" #inlineCheckbox{{tag.id}}>
                                        <label class="form-check-label" for="inlineCheckbox{{tag.id}}">{{tag.tag}}</label>
                                    </div>

                                    <div *ngIf="submitted && f?.rfqVendorCategory?.errors" class="invalid-feedback">
                                        <div *ngIf="f?.rfqVendorCategory?.errors?.required">Vendor Category is required</div>
                                    </div>
                                </div>
                            </div>

                        </div>



                <div class="col-12 mb-3">
                  <div class="container cd-content py-md-3 px-md-4">

                    <div class="cd-content">

                        <div class="row">

                            <div class="col-sm-6">
                                <div class="form-group mb-2 row">
                                    <label for="country"  class="col-sm-12 col-form-label">{{'rfq.form.ship_to' | translate}} <font class="text-danger pe-1">*</font> <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.ship_to' | translate}}"  container="body"></i></sup> </label>
                                    <div class="col-sm-12">
                                        <select formControlName="country" [(ngModel)]="ValCountry" class="form-select form-control placeholderRfq d-none" [ngClass]="{ 'is-invalid': submitted && f?.country?.errors }">
                                            <option value="" style="color:red !important;" hidden>Select Location</option>
                                            <!-- <option *ngFor="let country of countries" [ngValue]="country.id">{{country.countryName}}</option> -->

                                            <option *ngFor="let loc of getCompanyLocation" [ngValue]="loc.id">{{loc.label? loc.label+", ":""}}{{loc.street}}, {{loc.province}}, {{loc.country}}</option>
                                            


                                        </select>

                                        <!-- direct-open modal when no addresses exist -->
                                        <div *ngIf="!getCompanyLocation || getCompanyLocation.length === 0"
                                            class="divcategories placeholderRfq locationlist pointer"
                                            [ngClass]="{ 'invalidcategories': submitted && f?.country?.errors }"
                                            (click)="openAddAddressModal()">
                                            <div class="row g-0 pointer">
                                                <div class="col-11">
                                                    <font class="placeholderRfq">{{ValCountryShow}}</font>
                                                </div>
                                                <div class="col-1 text-end">
                                                    <i class="bi bi-chevron-down"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="getCompanyLocation && getCompanyLocation.length > 0"
                                            ngbDropdown class="btn btn-sm p-0 w-100 text-start pointer">
                                            <div class="divcategories placeholderRfq locationlist pointer" [ngClass]="{ 'invalidcategories': submitted && f?.country?.errors }" ngbDropdownToggle>
                                                <div class="row g-0 pointer">
                                                    <div class="col-11">
                                                        <font class="placeholderRfq">{{ValCountryShow}}</font>
                                                    </div>
                                                    <div class="col-1 text-end">
                                                        <i class="bi bi-chevron-down"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="" ngbDropdownMenu>
                                                <div *ngFor="let loc of getCompanyLocation; let i = index">
                                                    <div class="d-flex align-items-center" ngbDropdownItem>
                                                        <a class="locationlistdata f1l flex-grow-1 " (click)="selectShipTo(loc)">{{loc.label? loc.label+", ":""}}{{loc.street}}, {{loc.province}}, {{loc.country}}</a>
                                                        <i *ngIf="loc.isPending" class="bi bi-x-lg text-danger ms-2 pointer" style="font-size:12px" (click)="$event.stopPropagation(); removeAddress(loc)"></i>
                                                    </div>
                                                    <div class="dropdown-divider" *ngIf="i+1 !== getCompanyLocation.length"></div>
                                                </div>
                                                <div class="dropdown-divider" *ngIf="getCompanyLocation.length === 0" ></div>
                                                <a *ngIf="getCompanyLocation.length === 0" class="locationlistdata f1l text-center fhcyan fw-bold" (click)="openAddAddressModal()" ngbDropdownItem>+ {{'rfq.add_new_address' | translate}}</a>
                                            </div>
                                        </div>
                                        
                                        
                                    


                                        <div *ngIf="submitted && f?.country?.errors" class="invalid-feedback">
                                            <div *ngIf="f?.country?.errors?.required">'{{'rfq.form.ship_to' | translate}}' {{'required' | translate}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-2 row">
                                    <label for="paymentTermRequestedInDays" class="col-sm-12 col-form-label">{{'rfq.form.payment_term' | translate}} <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.payment_term' | translate}}"  container="body"></i></sup></label>
                                    <div class="col-sm-12">
                                        
                                        <div class="input-group">


                                            <input  class="form-control noscroll" [ngModelOptions]="{standalone: true}"
                                            [ngAutonumeric]="paymentTermOption" [(ngModel)]="ValpaymentTermRequestedInDays" (ngModelChange)="onPaymentTermChange($event)" placeholder="" 
                                            />


                                            <!-- <input type="text" class="form-control valuefont" id="paymentTermRequestedInDays" placeholder="Qty" [(ngModel)]="ValpaymentTermRequestedInDays" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && CheckVal(ValpaymentTermRequestedInDays) }"> -->

                                            <input type="number"  [ngModelOptions]="{standalone: true}" [ngModel]="ValpaymentTermRequestedInDays"  class="form-control placeholderRfq d-none" [ngClass]="{ 'is-invalid': submitted && f?.paymentTermRequestedInDays?.errors }" min="1" />
                                            <!-- <input type="number" [(ngModel)]="ValpaymentTermRequestedInDays" formControlName="paymentTermRequestedInDays" class="form-control placeholderRfq d-none" [ngClass]="{ 'is-invalid': submitted && f?.paymentTermRequestedInDays?.errors }" min="1" /> -->
                                            <span id="daysTerm" class="groupActive input-group-text">{{'days' | translate}}</span>

                                            <div *ngIf="submitted && CheckValNumber(ValpaymentTermRequestedInDays)" class="invalid-feedback">
                                                <div>{{'rfq.form.payment_term' | translate}} {{'required' | translate}}</div>
                                            </div>

                                        </div>
                                        <!-- <div *ngIf="submitted && f?.paymentTermRequestedInDays?.errors" class="invalid-feedback">
                                            <div *ngIf="f?.paymentTermRequestedInDays?.errors?.required">Payment term is required</div>
                                        </div> -->


                                    </div>
                                </div>


                                <div class="mb-2 row">
                                    <label for="etaRequested" class="col-sm-12 col-form-label">{{'rfq.form.eta_requested' | translate}}
                                        <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.eta_requested' | translate}}"  container="body"></i></sup> 
                                    </label>
                                    <div class="col-sm-12">
                                        <!-- <input type="text" [(ngModel)]="ValetaRequested" formControlName="etaRequested" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.etaRequested?.errors }" /> -->

                                        <div class="input-group">

                                            <input type="text"  class="form-control placeholderRfq readonly" placeholder="Select Date"  (ngModelChange)="changeDateEta($event)"  value="{{ValetaRequestedPreview}}" (click)="d1.toggle()"  [ngClass]="{ 'is-invalid': submitted && f?.etaRequested?.errors }" readonly> 
                                            <button class="btn btn-secondary bgGroupBtn" type="button"  (click)="d1.toggle()" [ngClass]="{ 'errCalendarBorder': submitted && f?.etaRequested?.errors }">
                                                <i class="cdc1 bi bi-calendar-event"></i>
                                            </button>
                                        </div>



                                        <div class="input-group">
                                            <input type="text" class="form-control placeholderRfq readonly divdatepicker" placeholder="Select Date"
                                            name="dp1" [(ngModel)]="ValetaRequested" formControlName="etaRequested"  ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="changeDateEta($event)"  (click)="d1.toggle()" [minDate]="minDate" [ngClass]="{ 'is-invalid': submitted && f?.etaRequested?.errors }" readonly> 
                                            <button class="btn btn-secondary bgGroupBtn d-none" type="button"  (click)="d1.toggle()" >
                                                <i class="cdc1 bi bi-calendar-event"></i>
                                            </button>

                                        </div>
                                        
                                        <!-- <p class="mb-0 mt-1 labelnotes">ETA is before valid date</p> -->

                                        <div *ngIf="submitted && f?.etaRequested?.errors" class="invalid-feedback">
                                            <div *ngIf="f?.etaRequested?.errors?.required">ETA {{'required' | translate}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-2 row">
                                    <label for="submitQuotationLastDate" class="col-sm-12 col-form-label">{{'rfq.form.rfq_valid_until' | translate}} <font class="text-danger pe-1">*</font> <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.valid_until' | translate}}"  container="body"></i></sup></label>
                                    <div class="col-sm-12">
                                        <!-- <input type="text" [(ngModel)]="ValsubmitQuotationLastDate" formControlName="submitQuotationLastDate" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.submitQuotationLastDate?.errors }" /> -->


                                        <div class="input-group">
                                            <input type="text" class="form-control placeholderRfq readonly" value="{{ValsubmitQuotationLastDatePreview}}" (ngModelChange)="changeDate($event)" (click)="d2.toggle()" [ngClass]="{ 'is-invalid': submitted && f?.submitQuotationLastDate?.errors }" readonly> 
                                            <a class="btn btn-secondary bgGroupBtn" [ngClass]="{ 'errCalendarBorder': submitted && f?.submitQuotationLastDate?.errors }"  type="button"  (click)="d2.toggle()" ><i class="cdc1 bi bi-calendar-event"></i></a>
                                            
                                            <div *ngIf="submitted && f?.submitQuotationLastDate?.errors" class="invalid-feedback">
                                                <div *ngIf="f?.submitQuotationLastDate?.errors?.required">{{'rfq.form.rfq_valid_until' | translate}} {{'required' | translate}} </div>
                                            </div>
                                        </div>


                                        <div class="input-group">
                                            <input type="text" class="form-control placeholderRfq readonly divdatepicker" placeholder="Select Date"
                                            name="dp2" [(ngModel)]="ValsubmitQuotationLastDate" (ngModelChange)="changeDate($event)" formControlName="submitQuotationLastDate"  ngbDatepicker #d2="ngbDatepicker"  (click)="d2.toggle()" [minDate]="minDate" [maxDate]="maxDate" [ngClass]="{ 'is-invalid': submitted && f?.submitQuotationLastDate?.errors }" readonly> 
                                            <a class="btn btn-secondary bgGroupBtn d-none" [ngClass]="{ 'errCalendarBorder': submitted && f?.submitQuotationLastDate?.errors }"  type="button"  (click)="d2.toggle()" ><img src="/assets/images/icons/Subtract.png"></a>
                                            
                                            <div *ngIf="submitted && f?.submitQuotationLastDate?.errors" class="invalid-feedback">
                                                <div *ngIf="f?.submitQuotationLastDate?.errors?.required">{{'rfq.form.rfq_valid_until' | translate}}  {{'required' | translate}} </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>
                                

                            </div>

                            
                            <div class="col-sm-6">
                                <div class="mb-2 row">
                                    <label for="currency" class="col-sm-12 col-form-label">{{'rfq.form.currency' | translate}}  <font class="text-danger pe-1">*</font> <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.currency' | translate}}"  container="body"></i></sup></label>
                                    <div class="col-sm-12">


                                        <!-- <select formControlName="currency" [(ngModel)]="Valcurrency" class="form-select form-control" [ngClass]="{ 'is-invalid': submitted && f?.currency?.errors }">
                                            <option *ngFor="let country of countries" [ngValue]="country.currency">{{country.currency}} ({{country.countryName}})</option>
                                        </select> -->

                                        <input formControlName="currency"  id="typeahead-format" type="text" class="form-control placeholderRfq" [(ngModel)]="Valcurrency" placeholder="Input Currency" [ngbTypeahead]="search" [resultFormatter]="formatter"  [editable]='false' [ngClass]="{ 'is-invalid': submitted && f?.currency?.errors }" (ngModelChange)="getCurrency($event)" />


                                        <div *ngIf="submitted && f?.currency?.errors" class="invalid-feedback">
                                            <div *ngIf="f?.currency?.errors?.required">Please type and select currency from the list</div>
                                        </div>

                                    </div>
                                </div>

                                
                                

                                <div class="mb-2 row">
                                    <label for="procurementRefNumber" class="col-sm-12 col-form-label">Internal Ref. No <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.internal_ref_info' | translate}}"  container="body"></i></sup> </label>
                                    <div class="col-sm-12">
                                        <input type="text" [(ngModel)]="ValprocurementRefNumber" formControlName="procurementRefNumber" class="form-control placeholderRfq" [ngClass]="{ 'is-invalid': submitted && f?.procurementRefNumber?.errors }" placeholder="Type Internal  Ref. No." />
                                        <div *ngIf="submitted && f?.procurementRefNumber?.errors" class="invalid-feedback">
                                            <div *ngIf="f?.procurementRefNumber?.errors?.required">Internal Ref. No is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-2  ps-0 row g-0 pt-2 pt-sm-0">
                                    <div class="form-check form-switch mb-0 col-auto">
                                        <input class="form-check-input"  (change)="onCheckisForFullQuote($event)" type="checkbox" id="isForFullQuote" [(ngModel)]="ValisForFullQuote" formControlName="isForFullQuote">
                                        <label for="isForFullQuote">Only Full Quotes Accepted </label>
                                    </div>
                                    <div class="col-1 p-0 ps-1"><sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.only_full_quote' | translate}}"  container="body"></i></sup></div>
                                </div>

                                <div class="mb-2 ps-0 row g-0">
                                    <div class="form-check form-switch mb-0 mb-sm-3 col-auto">
                                        <input class="form-check-input"  (change)="onCheckisIndentAccepted($event)" type="checkbox" id="isIndentAccepted" [(ngModel)]="ValisIndentAccepted" formControlName="isIndentAccepted">
                                        <label for="isIndentAccepted">Indent (Backorder) Accepted</label>
                                    </div>    
                                    <div class="col-1 p-0 ps-1"><sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.indent' | translate}}"  container="body"></i></sup></div>
                                </div>

                                <!-- <div class="mb-2 mb-sm-3 ps-0 row g-0">
                                    <a class="btn btn-sm"  (click)="open(content)"><u>Recommended a category</u></a> <font><sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.recommend_category' | translate}}"  container="body"></i></sup></font> 
                                </div> -->

                            </div>

                        </div>

                        <div class="option-title my-4 {{ (emptyitem)?'text-danger':'' }}">Daftar permintaan produk</div>

                        <!-- products list -->
                        <div class="cd-rfq-product">

                        <div *ngIf="productList?.length === 0" class="text-center py-5">
                            <p class="text-muted mb-3">{{'rfq.empty_product_list' | translate}}</p>
                            <a class="btn btn-default text-white fhbtn4 rounded-1" (click)="addProduct()">+ Add New Product</a>
                        </div>


                        <div class="mb-3" *ngFor="let product of productList; let i = index" [ngClass]="{ 'bg4': submitted && emptyitem}">
                            <ngb-accordion [closeOthers]="true" activeIds="static-{{product.itemSequence}}">
                            <ngb-panel id="static-{{product.itemSequence}}">

                                <ng-template ngbPanelHeader let-opened="opened">
                                <button ngbPanelToggle class="btn btn-link p-0 w-100 text-decoration-none">
                                    <div class="d-flex align-items-center justify-content-between px-3 py-2 cd-rfq-product-title cdprocbg1 text-white">
                                    <p class="mb-0"><b>
                                        <div [innerHTML]="checkName(ValdescriptionProduct[i],Valbrand[i])"></div>
                                    </b></p>
                                    <a class="btn btn-link p-0">
                                        <h4 class="mb-0 bi bi-chevron-{{ opened ? 'up' : 'down' }} text-white"></h4>
                                    </a>
                                    </div>
                                </button>

                                </ng-template>

                                <ng-template ngbPanelContent>


                                <div class="cd-rfq-product-quote p-3 mb-3">

                                    <div class="row">

                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <label for="brand_{{i}}" class="form-label labelfont">Brand <sup><i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" placement="top auto" ngbTooltip="{{'rfq.brand' | translate}}"  container="body"></i></sup></label>
                                            <input type="text" class="form-control valuefont" id="brand_{{i}}" placeholder="Masukkan Merek Produk" [name]="'brand_' + i" [(ngModel)]="Valbrand[i]" [ngModelOptions]="{standalone: true}"  >
                                        </div>

                                        <div class="mb-3">
                                            <label for="exampleFormControlTextarea1" class="form-label">Deskripsi Produk <font class="text-danger">*</font></label>
                                            <textarea class="form-control shortdesc" id="descriptionProduct_{{i}}"
                                            placeholder="Deskripsikan Produk Yang Dibutuhkan" rows=""
                                            [name]="'descriptionProduct_' + i" [(ngModel)]="ValdescriptionProduct[i]"
                                            [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && CheckVal(ValdescriptionProduct[i]) }"></textarea>
                                            <p class="iserror m-0" [hidden]="!(submitted && CheckVal(ValdescriptionProduct[i]))">Deskripsi Produk wajib diisi</p>
                                        </div>

                                        <div class="mb-3 isHide">
                                            <label class="">
                                            Gambar Produk
                                            </label>
                                            <div class="mb-2 d-none">
                                            <label  class="form-label labelfont">Product Image</label>
                                                <input class="form-control" type="file" id="formFile_{{i}}" [ngModelOptions]="{standalone: true}"  [(ngModel)]="ValimageMoreText[i]"
                                                (change)="onFileChangeMultipleUpload($event,i)"> <!-- multiple -->
                                                <!-- <p class="iserror" [hidden]="!(submitted && CheckVal(ValdescriptionProduct[i]))">Product description is required</p> -->
                                            </div>

                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="row g-0">
                                                        <ng-container  *ngFor="let MoreImg of imageSrcMore[i]; let j = index">
                                                            <div class="col-4 col-sm-2 col-md-2 col-lg-2 ps-1 pe-1 pt-1 pb-1 pointer {{imageSrcMore[i][j]?'':'d-nonex'}}">

                                                                <div class="text-center bg-light border rounded-3 thumbimgdivMore col-sm-12 col-md-4 col-lg-4 ps-1 pe-1 pt-1 pb-1 pointer" *ngIf="imageSrcMore[i][j]" (click)="MoreImgFileClick('MoreImg'+j)">
                                                                    <img [src]="'imgs/'+imageSrcMore[i][j]?.val" *ngIf="imageSrcMore[i][j]?.val" class="thumbimgdivinnerMore" appImgFallback>
                                                                </div>
                                                                <p class="text-center mb-0 pb-0 thumbimgdivDelete"  *ngIf="imageSrcMore[i][j]">
                                                                    <i class="bi bi-trash text-danger"  *ngIf="imageSrcMore[i][j]?.val" (click)="MoreImgRemoveFile(j,i)"></i>
                                                                </p>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <div class="col-12" *ngIf="!imageSrcMore[i] || imageSrcMore[i]?.length ==0">
                                                <div (click)="triggerFileInput(i)">
                                                    <img src="/assets/images/empty-img.png" style="cursor: pointer;max-width: 88px;border-radius: 4px;">
                                                </div>
                                                </div>
                                                <div class="col-12">
                                                <small style="color: #efaa00; font-size: 12px;">*Format: .jpg, .jpeg, .gif, .png (Maks 8MB (600x600 piksel))</small>
                                                </div>

                                                <div class="col-12" *ngIf="errorUploadImg[i]">
                                                    <div>
                                                        <p *ngIf="errorUploadImg[i]" class="text-danger imgnotif">{{ errorUploadImg[i] }}</p>
                                                    </div>                              
                                                </div>



                                            </div>
                                        </div>

                                        
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                        <label for="manufacturerSku_{{i}}" class="form-label">Nomor SKU</label>
                                        <input type="text" class="form-control" id="manufacturerSku_{{i}}"
                                        placeholder="Masukkan Nomor SKU" [name]="'manufacturerSku_' + i"
                                        [(ngModel)]="ValmanufacturerSku[i]" [ngModelOptions]="{standalone: true}">    
                                        </div>

                                        <div class="mb-3">
       
                                        <div class="row">
                                            <div class="col-6">

                                                <label for="exampleFormControlInput1" class="form-label labelfont mb-0">QTY Requested <font class="text-danger">*</font>
                                                <sup class="ps-1">
                                                <i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" ngbTooltip="{{'rfq.qty_requested' | translate}}" container="body"></i>
                                                </sup>
                                                </label>
                                                    <input  class="form-control noscroll" [ngModelOptions]="{standalone: true}"
                                                    [ngAutonumeric]="thousandQtyOption" [(ngModel)]="ValqtyNeededPrev[i]" placeholder="Qty" [ngClass]="{ 'is-invalid': submitted && CheckValNumber(ValqtyNeeded[i]) }"  (format)="changeQtyPrev($event,i)" (change)="changeQtyPrev($event,i)"/>
                                                    <p class="iserror" [hidden]="!(submitted && CheckValNumber(ValqtyNeeded[i]))">Qty is required</p>

                                                    <input type="hidden" class="form-control valuefont" id="qtyNeeded_{{i}}" placeholder="Qty" [name]="'qtyNeeded_' + i" [(ngModel)]="ValqtyNeeded[i]" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && CheckVal(ValqtyNeeded[i]) }">
                                        
                                            </div>
                                            <div class="col-6">
                                                    <label for="exampleFormControlInput1" class="form-label labelfont mb-0">QTY Units <font class="text-danger">*</font>
                                                        <sup class="ps-1">
                                                        <i class="bi bi-info-circle pointer" triggers="click" [autoClose]="'outside'" ngbTooltip="{{'rfq.qty_units' | translate}}" container="body"></i>
                                                        </sup>
                                                        </label>                                                    
                                                    <input type="text" class="form-control valuefont" id="qtyUnit_{{i}}" placeholder="Ex. Pcs." [name]="'qtyUnit_' + i" [(ngModel)]="ValqtyUnit[i]" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && CheckVal(ValqtyUnit[i]) }">
                                            </div>
                                        </div>
                                        </div>


                                        <div class="mb-3">
                                        <div class="row">
                                            <div class="col-5">
                                            <label class="labelfont">Label</label>
                                            </div>
                                            <div class="col-5">
                                            <label class="labelfont">Spesifikasi</label>
                                            </div>
                                            <div class="col-2">
                                            </div>
                                        </div>
                                        <div class="row mb-2" *ngFor='let in of countarrFhSpec[i];let x = index'>
                                            <div class="col-5">
                                            <input type="input" value="{{in.label}}" class="form-control valuefont"
                                                (input)="changeLabelSpec(i,in,$event)"
                                                [ngClass]="{ 'is-invalid-skip': emptyLabelSpec[i][x]?.error }"
                                                placeholder="Contoh: Warna" maxlength="20" required>
                                            </div>
                                            <div class="col-5">
                                            <input type="input" value="{{in.value}}" class="form-control valuefont"
                                                (input)="changeValueSpec(i,in,$event)"
                                                [ngClass]="{ 'is-invalid-skip': emptyValueSpec[i][x]?.error }"
                                                placeholder="Contoh: Hitam" maxlength="50" required>
                                            </div>
                                            <div class="col-2">
                                            <a class="btn pointer text-center" (click)="removeSpec(i,in)"
                                                style="border: 0px !important">
                                                <i class="bi bi-x-lg"></i>
                                            </a>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5">
                                            <input type="input" class="form-control valuefont"
                                                [(ngModel)]="valspecLabel[i]"
                                                [ngClass]="{ 'is-invalid-skip': valspecLabelErr[i] }"
                                                [ngModelOptions]="{standalone: true}" (input)="firstLabelSpec(i,$event)"
                                                maxlength="20" placeholder="Contoh: Warna">
                                            </div>
                                            <div class="col-5">
                                            <input type="input" class="form-control valuefont"
                                                [(ngModel)]="valspecValue[i]"
                                                [ngClass]="{ 'is-invalid-skip': valspecValueErr[i] }"
                                                [ngModelOptions]="{standalone: true}" (input)="firstValueSpec(i,$event)"
                                                maxlength="50" placeholder="Contoh: Hitam">
                                            </div>
                                            <div class="col-2">
                                            <!-- <a class="btn pointer text-center me-2 disabled" *ngIf="!ValSpecEmpty[i]"
                                                style="border: 0px !important">
                                                <i class="bi bi-x-lg"></i>
                                            </a> -->
                                            <!-- <a class="btn pointer text-center me-2" *ngIf="ValSpecEmpty[i]"
                                                (click)="clearSpec(i)" style="border: 0px !important">
                                                <i class="bi bi-x-lg"></i>
                                            </a> -->
                                            <a class="btn text-white pointer text-end morespec plusIcon" (click)="addSpec(i)"> 
                                                <font><i class="bi bi-plus-square"></i></font>
                                            </a>
                                            </div>
                                        </div>
                                        </div>                        



                                        

                                    </div>

                                    <div class="col-12">
                                        
                                        <div class="d-flex flex-row-reverse">
                                        <div class="text-center">
                                            <button type="button" class="btn btn-outline-danger fw-bold"  (click)="removeProduct(i)" style="border:0px !important"><i class="bi bi-trash"></i> Delete Product</button>
                                        </div>
                                        </div>

                                    </div>

                                    </div>
                                </div>                  

                                <div class="d-flex flex-row-reverse">
                                    <div class="text-center">
                                    </div>
                                </div>

                                </ng-template>
                            </ngb-panel>
                            </ngb-accordion>
                        </div>
                        


                        </div>
                        <!--/products list -->

                    </div>

                  </div>
                </div>
              </div>

            </div>
          </form>


</div>



















<div class="fixed-bottom">

    <div class="bg-white py-3 d-block d-sm-none">
        <div class="container">
          <div class="row g-0">
            <div class="col-2">
                <div class="px-1">
    
    
                    <div ngbDropdown placement="top-right" class="d-inline-block mbtnmore w-100">
                        <a class="btn btn-link btnlinkmore rounded-1 roundedmore w-100 text-dark" ngbDropdownToggle>
                            <i class="bi bi-three-dots"></i>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                            <button class="fw-bold py-2" ngbDropdownItem ngbDropdownToggle><i class="bi bi-x-lg"></i> Lainnya</button>
    
 

                            <!-- <a *ngIf="!pageloading" class="fh4 fw-bold py-2 pointer" (click)="submitaction('draft')" ngbDropdownItem>Save Draft</a>
                            <a *ngIf="pageloading" class="fh4 fw-bold py-2 pointer"  disabled ngbDropdownItem>Loading..</a> -->

                            <hr class="m-0">

                            <a class="fw-bold  text-danger py-2 pointer" href="/" ngbDropdownItem>Kembali</a>

                            <!-- <hr class="m-0">

                            <a class="fhcyan fw-bold py-2 pointer" (click)="submitaction('preview')" ngbDropdownItem>View RFQ</a> -->

                            
                        </div>
                    </div>
    
                </div>
    
            </div>
            <div class="col-5">
                <div class="px-1">
                    <a class="btn btn-default text-white fhbtn4 rounded-1 roundedmore w-100 py-2"  (click)="addProduct()">+ Add New Product</a>
                </div>
            </div>
            <div class="col-5">
                <div class="px-1">
                    <button  type="button" (click)="submitaction('draft')" class="btn btn-primary fhbcyan rounded-1 roundedmore w-100 py-2" *ngIf="!pageloading">Save</button>
                    <button class="btn btn-primary fhbcyan rounded-1 roundedmore w-100 py-2" *ngIf="pageloading" disabled>Loading..</button>
                </div>
            </div>
          </div>
        </div>
    </div> 


    <div class="bg-white py-2 d-none d-sm-block">
      <div class="container">
        <div class="row g-0">
          <div class="col-6">

            <!-- <button type="button" (click)="submitaction('draft')" class="btn btn-dark fhbtn3 rounded-1 roundedmore fixwbtn mb-1 mt-1 me-3 ps-4 pe-4"  *ngIf="!pageloading">Save Draft</button>
            <button class="btn btn-dark fhbdark rounded-1 roundedmore fixwbtn mb-1 mt-1 me-3 ps-4 pe-4" *ngIf="pageloading" disabled>Loading..</button> -->
  
            <a class="btn btn-danger fhbgred rounded-1 roundedmore fixwbtn mb-1 mt-1 ps-4 pe-4" href="/">Kembali</a>


  
          </div>
          <div class="col-6 text-end">

            <a class="btn btn-default text-white fhbtn4 rounded-1 roundedmore mb-1 mt-1 fixwbtnProduct mb-0 mt-0 ms-0 ps-0 pe-0"  (click)="addProduct()">+ Add New Product</a>

            <button  type="button" (click)="submitaction('draft')" class="btn btn-primary fhbcyan rounded-1 roundedmore fixwbtn mb-1 mt-1 ms-3 ps-4 pe-4" *ngIf="!pageloading">Save</button>
            <button class="btn btn-primary fhbcyan rounded-1 roundedmore fixwbtn mb-1 mt-1 ms-3 ps-4 pe-4" *ngIf="pageloading" disabled>Loading..</button>

            <!-- <button type="button" (click)="submitaction('preview')" class="btn btn-link rounded-1 roundedmore  c1 mb-1 mt-1 ms-3" *ngIf="!pageloading"><strong>View RFQ</strong></button>
            <button class="btn btn-dark fhbgblack rounded-1 roundedmore  mb-1 mt-1 ms-3" *ngIf="pageloading" disabled>Loading..</button> -->


  
            
          </div>
        </div>
      </div>
    </div>
</div>

<!-- Add Address Modal -->
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': addAddressModal}">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 cd-modal cd-content">
            <div class="modal-header cdbg2 text-center py-2">
                <h5 class="text-white f2 mb-0 w-100"><strong>{{'company_management.address' | translate}}</strong></h5>
                <button type="button" class="btn text-white" (click)="closeAddAddressModal()"><i class="bi bi-x-lg"></i></button>
            </div>
            <div class="modal-body filterdiv">
                <form [formGroup]="AddressForm" (ngSubmit)="onSubmitAddress()">
                    <div class="row">

                        <div class="col-lg-12 d-none">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.label_address' | translate}} <font class="text-danger">*</font></label>
                                <div class="input-group">
                                    <input type="text" [(ngModel)]="Vallabel" formControlName="addrLabel" class="form-control"
                                        [ngClass]="{'is-invalid': addresssubmitted && g?.addrLabel?.errors}"
                                        [placeholder]="'company_management.office_address' | translate" />
                                    <div *ngIf="addresssubmitted && g?.addrLabel?.errors" class="invalid-feedback">
                                        <div *ngIf="g?.addrLabel?.errors?.required">{{'company_management.label_address' | translate}} {{'required' | translate}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.country' | translate}} <font class="text-danger">*</font></label>
                                <div class="input-group">
                                    <ng-multiselect-dropdown class="w-100"
                                        [ngClass]="{'is-invalid': addresssubmitted && g?.addrCountry?.errors}"
                                        [placeholder]="'company_management.select_country' | translate"
                                        [data]="countriesAddr"
                                        [(ngModel)]="Valcountry"
                                        formControlName="addrCountry"
                                        [settings]="dropdownSettings"
                                        (onSelect)="onItemSelectCountryAddr($event)"
                                        (onDeSelect)="onItemDeselectCountryAddr($event)">
                                    </ng-multiselect-dropdown>
                                    <div *ngIf="addresssubmitted && g?.addrCountry?.errors" class="invalid-feedback d-block">
                                        <div *ngIf="g?.addrCountry?.errors?.required">{{'company_management.country' | translate}} {{'required' | translate}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.city' | translate}} <font class="text-danger">*</font></label>
                                <div class="input-group">
                                    <ng-multiselect-dropdown class="w-100"
                                        [ngClass]="{'is-invalid': addresssubmitted && g?.addrCity?.errors}"
                                        [placeholder]="'company_management.select_city' | translate"
                                        [data]="cities"
                                        [(ngModel)]="Valcity"
                                        formControlName="addrCity"
                                        [settings]="dropdownSettings"
                                        (onSelect)="onItemSelectCityAddr($event)">
                                    </ng-multiselect-dropdown>
                                    <div *ngIf="addresssubmitted && g?.addrCity?.errors" class="invalid-feedback d-block">
                                        <div *ngIf="g?.addrCity?.errors?.required">{{'company_management.city' | translate}} {{'required' | translate}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.province' | translate}}</label>
                                <div class="input-group">
                                    <input type="text" [(ngModel)]="Valprovince" [ngModelOptions]="{standalone: true}" class="form-control"
                                        [placeholder]="'company_management.province' | translate" />
                                </div>
                            </div>
                        </div>



                        <div class="col-lg-12">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.input_address' | translate}} <font class="text-danger">*</font></label>
                                <div class="input-group">
                                    <input type="text" [(ngModel)]="Valstreet" formControlName="addrStreet" class="form-control"
                                        [ngClass]="{'is-invalid': addresssubmitted && g?.addrStreet?.errors}"
                                        [placeholder]="'company_management.input_address' | translate" />
                                    <div *ngIf="addresssubmitted && g?.addrStreet?.errors" class="invalid-feedback">
                                        <div *ngIf="g?.addrStreet?.errors?.required">{{'company_management.input_address' | translate}} {{'required' | translate}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.zip_code' | translate}}</label>
                                <div class="input-group">
                                    <input type="text" [(ngModel)]="ValpostalCode" [ngModelOptions]="{standalone: true}" class="form-control"
                                        [placeholder]="'company_management.input_zip_code' | translate" />
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.phone' | translate}}</label>
                                <div class="input-group">
                                    <input type="text" [(ngModel)]="Valphone" [ngModelOptions]="{standalone: true}" class="form-control"
                                        [placeholder]="'company_management.phone' | translate" />
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 d-none">
                            <div class="row mb-2">
                                <label class="col-sm-12 col-form-label pb-0">{{'company_management.tax_id' | translate}}</label>
                                <div class="input-group">
                                    <input type="text" [(ngModel)]="ValtaxId" [ngModelOptions]="{standalone: true}" class="form-control"
                                        [placeholder]="'company_management.tax_id' | translate" />
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row mt-3">
                        <div class="col-sm-6 mb-3">
                            <button type="button" class="btn c1 pe-5 ps-5 f2 cdoutbtn2 cdborder2 cdc2 fsmall w-100" (click)="closeAddAddressModal()">{{'cancel' | translate}}</button>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <button type="submit" *ngIf="!addressloading" class="btn f2 cdbtn2 cdborder2 text-white pe-5 ps-5 fsmall w-100">{{'save' | translate}}</button>
                            <button type="button" *ngIf="addressloading" class="btn f2 cdbtn2 cdborder2 text-white pe-5 ps-5 fsmall w-100" disabled>Loading..</button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>

<!-- Email modal before redirect to register -->
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': emailDraftModal}">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 cd-modal cd-content">
            <div class="modal-header cdbg2 text-center py-2">
                <h5 class="text-white f2 mb-0 w-100"><strong>Masukkan Email Anda</strong></h5>
                <button type="button" class="btn text-white" (click)="closeEmailDraftModal()"><i class="bi bi-x-lg"></i></button>
            </div>
            <div class="modal-body p-4">
                <p class="text-center cdc1 mb-3">Masukkan email untuk proses publish RFQ Anda.</p>
                <div class="mb-3">
                    <label class="form-label cdc1 fw-bold">Email <font class="text-danger">*</font></label>
                    <input type="email" class="form-control"
                        [(ngModel)]="ValDraftEmail"
                        [ngClass]="{'is-invalid': emailDraftSubmitted && (!ValDraftEmail || !ValDraftEmail.includes('@'))}"
                        placeholder="contoh@email.com" />
                    <div class="invalid-feedback" *ngIf="emailDraftSubmitted && (!ValDraftEmail || !ValDraftEmail.includes('@'))">
                        Email tidak valid.
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <button type="button" class="btn c1 f2 cdoutbtn2 cdborder2 cdc2 fsmall w-100" (click)="closeEmailDraftModal()">Batal</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="btn f2 cdbtn2 cdborder2 text-white fsmall w-100" (click)="submitEmailDraft()" [disabled]="emailDraftLoading">
                            <span *ngIf="emailDraftLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            {{ emailDraftLoading ? 'Memproses...' : 'Lanjutkan' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


